import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Input } from '@mui/material';

function TextInput({
  value,
  onChange,
  disabled,
  readOnly,
  maxLength,
  errored,
  rows,
  id,
  margin,

}) {
  const onChangeHandler = useCallback(
    (e) => {
      const newValue = e.target.value;
      if (!readOnly && (!maxLength || newValue.length <= maxLength)) {
        onChange(e, newValue);
      }
    },
    [maxLength, onChange, readOnly],
  );
  return (
    <Input
      id={id}
      value={value || ''}
      onChange={onChangeHandler}
      disabled={disabled}
      error={errored}
      readOnly={readOnly}
      multiline
      rows={rows}
      margin={margin}
      fullWidth
    />
  );
}

TextInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  maxLength: PropTypes.number,
  errored: PropTypes.bool,
  rows: PropTypes.number,
  margin: PropTypes.oneOf(['none', 'normal', 'dense']),
};

TextInput.defaultProps = {
  id: null,
  value: '',
  disabled: false,
  readOnly: false,
  maxLength: 0,
  errored: false,
  rows: 3,
  margin: 'dense',
};

export default memo(TextInput);
